/**
 * Core Web Vitals reporting.
 *
 * Measures LCP, FID, CLS, FCP, and TTFB using the web-vitals library
 * (included with Create React App) and sends them to Google Analytics 4
 * via the `trackPerformance` helper.
 *
 * Call `reportWebVitals()` once in index.js after the app mounts.
 */
import { trackPerformance } from './analytics';

const sendToGA = ({ name, delta, id }) => {
  trackPerformance(name, Math.round(delta), 'ms');
};

const reportWebVitals = () => {
  // Dynamic import so the library is only loaded after first paint
  import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
    onCLS(sendToGA);
    onFID(sendToGA);
    onFCP(sendToGA);
    onLCP(sendToGA);
    onTTFB(sendToGA);
    // INP (Interaction to Next Paint) — the newer replacement for FID
    if (onINP) onINP(sendToGA);
  }).catch(() => {
    // web-vitals not available — no-op
  });
};

export default reportWebVitals;
